

export class UserSecurityEditDto {
  constructor(
    public id: number,
    public isLocked: boolean,
    public role: string
  ) {
  }
}
